// src/features/loading/loadingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  loadingCount: 0,
  loadingMessage: 'Loading...',
  loadingActions: [], // Use array instead of Set for Redux serialization
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    startLoading: (state, action) => {
      const { actionType, message } = action.payload || {};
      
      if (actionType && !state.loadingActions.includes(actionType)) {
        state.loadingActions.push(actionType);
      }
      
      state.loadingCount += 1;
      state.isLoading = true;
      
      if (message) {
        state.loadingMessage = message;
      }
    },
    stopLoading: (state, action) => {
      const { actionType } = action.payload || {};
      
      if (actionType) {
        state.loadingActions = state.loadingActions.filter(action => action !== actionType);
      }
      
      state.loadingCount = Math.max(0, state.loadingCount - 1);
      state.isLoading = state.loadingCount > 0;
      
      // Reset message when no loading is happening
      if (!state.isLoading) {
        state.loadingMessage = 'Loading...';
      }
    },
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload;
    },
    clearAllLoading: (state) => {
      state.isLoading = false;
      state.loadingCount = 0;
      state.loadingMessage = 'Loading...';
      state.loadingActions = [];
    }
  }
});

export const { 
  startLoading, 
  stopLoading, 
  setLoadingMessage, 
  clearAllLoading 
} = loadingSlice.actions;

export default loadingSlice.reducer;

// Selectors
export const selectIsLoading = (state) => state.loading.isLoading;
export const selectLoadingMessage = (state) => state.loading.loadingMessage;
export const selectLoadingCount = (state) => state.loading.loadingCount;
export const selectIsActionLoading = (actionType) => (state) => 
  state.loading.loadingActions.includes(actionType);